const PERMISSIONS = {
  'users.manage': ['admin'],
  'documents.read': ['admin', 'member', 'viewer'],
  'documents.write': ['admin', 'member'],
  'envelopes.read': ['admin', 'member', 'viewer'],
  'envelopes.write': ['admin', 'member'],
  'templates.read': ['admin', 'member', 'viewer'],
  'templates.write': ['admin', 'member'],
  'audit.read': ['admin', 'member', 'viewer'],
  'settings.write': ['admin'],
  'integrations.write': ['admin', 'member'],
  'email_templates.write': ['admin', 'member'],
};

export function normalizeRole(role) {
  const r = (role || 'member').toLowerCase();
  if (r === 'user') return 'member';
  if (['admin', 'member', 'viewer'].includes(r)) return r;
  return 'member';
}

export function can(user, permission) {
  if (!user) return false;
  const role = normalizeRole(user.role);
  return (PERMISSIONS[permission] || []).includes(role);
}

export const ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin', description: 'Full access and user management' },
  { value: 'member', label: 'Member', description: 'Create and send documents' },
  { value: 'viewer', label: 'Viewer', description: 'Read-only access' },
];
